import React from 'react'
import { useHistory } from 'react-router'
import PropTypes from 'prop-types'
import MenuWithChildren from './MenuWithChildren'
import MenuItem from './MenuItem'

import styles from './sidebar.module.scss'

const SideMenu = ({ menus, handleButtonExpand }) => {
  const history = useHistory()
  const currentPath = history.location.pathname

  return (
    <ul className={styles.menu}>
      {menus.map((menu) =>
        menu.children.length ? (
          <MenuWithChildren
            {...{
              currentPath,
              history,
              key: menu.optionId,
              menu,
              handleButtonExpand
            }}
          />
        ) : (
          <MenuItem
            {...{
              currentPath,
              key: menu.optionId,
              history,
              menu,
              handleButtonExpand
            }}
          />
        )
      )}
    </ul>
  )
}

SideMenu.defaultProps = {
  menus: [],
  handleButtonExpand: null
}

SideMenu.propTypes = {
  menus: PropTypes.array,
  handleButtonExpand: PropTypes.func
}

export default SideMenu
